import React from 'react';
import { FaCog } from 'react-icons/fa';

export default function SettingsPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-1">Configure platform settings</p>
      </div>

      <div className="dashboard-card text-center py-12">
        <FaCog className="mx-auto mb-4 text-gray-400" size={48} />
        <p className="text-gray-600">Settings panel coming soon</p>
      </div>
    </div>
  );
}
